import { render, staticRenderFns } from "./ScrapDetailView.vue?vue&type=template&id=a888d6d0"
import script from "./ScrapDetailView.vue?vue&type=script&lang=js"
export * from "./ScrapDetailView.vue?vue&type=script&lang=js"
import style0 from "./ScrapDetailView.vue?vue&type=style&index=0&id=a888d6d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports